

import { useParams } from "react-router-dom";
import { LayoutItemDeOp } from "../../layouts";
import { TablaModelarItems, DetallesImagenItem, InformacionItemXId } from "../components"
import { useCarritoXID } from "../../../hooks/cache";
import { CargandoMedio } from "../../components";







export const DetallesItemProduccion = () => {


    const { id } = useParams();
    const { data, isLoading } = useCarritoXID(id);  
    
    
    return (

        <LayoutItemDeOp titulo={'Información Item de OP'}>
            {(isLoading) 
            ?   <CargandoMedio titulo="Cargando información del item de compra" />

            :   <>
                <InformacionItemXId data={ data } />
                <TablaModelarItems producto={ data } />
                <DetallesImagenItem data={ data } />
                </>
            }
        </LayoutItemDeOp>
    )
}
